// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Header {
  --navigation-height: 60px;
  --quick-links-height: 40px;
  --filters-height: 54px;
  --info-height: 36px;
}

.Header {
  width: 100vw;
  z-index: 50;
}
.Header .NavigationDrawer-Button i {
  color: #fff;
  font-size: 2.5rem;
}
.Header .NavLinks,
.Header .Filters .FormField,
.Header .Filters .btn,
.Header .Dropdown {
  box-shadow: 4px 5px 16px 0px rgba(0, 0, 0, 0.35);
}
.Header > .row {
  background: var(--bs-primary);
  padding: 0 4rem;
}
.Header > .row + .row {
  border-top: 1px solid var(--bs-secondary-subtle);
}
.Header > .row > .col:not(.HeaderInfo > .col) {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.Header > .row.HeaderNavigation {
  background-image: url("../../../public/assets/images/Skyplan_header_Logo1.png");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: 50% calc(50% + 3px);
  background-size: auto calc(var(--navigation-height) - 10px);
  height: var(--navigation-height);
}
.Header > .row.HeaderNavigation .NavLinks {
  width: fit-content;
  height: var(--quick-links-height);
  padding: 0 1.5rem;
  border: 0.5px solid var(--bs-secondary-subtle);
}
.Header > .row.HeaderNavigation .NavLinks a {
  cursor: pointer;
  font-size: 1.9rem;
}
.Header > .row.HeaderNavigation .NavLinks a i:hover {
  color: var(--bs-secondary);
}
.Header > .row.HeaderFilters {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.Header > .row.HeaderFilters .Filters {
  background: var(--bs-primary);
  color: var(--bs-secondary-subtle);
}
.Header > .row.HeaderFilters .Filters .FormField-Wrapper,
.Header > .row.HeaderFilters .Filters .ant-picker,
.Header > .row.HeaderFilters .Filters .btn,
.Header > .row.HeaderFilters .Filters *:not(.grouped-input) > .form-control {
  height: var(--info-height) !important;
}
.Header > .row.HeaderFilters .Filters .ant-picker {
  border: 1px solid var(--bs-secondary-subtle);
  background-color: transparent;
}
.Header > .row.HeaderFilters .Filters .ant-picker .ant-picker-input input,
.Header > .row.HeaderFilters .Filters .ant-picker .ant-picker-input span {
  color: var(--bs-secondary-subtle);
}
.Header > .row.HeaderFilters .Filters .ant-picker:hover, .Header > .row.HeaderFilters .Filters .ant-picker.ant-picker-focused {
  border: 1px solid var(--bs-secondary) !important;
}
.Header > .row.HeaderFilters .Filters .ant-picker:hover .ant-picker-input input,
.Header > .row.HeaderFilters .Filters .ant-picker:hover .ant-picker-input span, .Header > .row.HeaderFilters .Filters .ant-picker.ant-picker-focused .ant-picker-input input,
.Header > .row.HeaderFilters .Filters .ant-picker.ant-picker-focused .ant-picker-input span {
  color: var(--bs-secondary);
}
.Header > .row.HeaderFilters .Filters .btn {
  border: 1px solid var(--bs-secondary-subtle);
}
.Header > .row.HeaderFilters .Filters .form-control {
  height: 100%;
  display: flex;
  align-items: center;
}
.Header > .row.HeaderFilters .Filters .form-control:not(.is-invalid) {
  border-color: var(--bs-secondary-subtle);
}
.Header > .row.HeaderFilters .Filters .btn:not(.btn-success),
.Header > .row.HeaderFilters .Filters .form-control,
.Header > .row.HeaderFilters .Filters .Select {
  color: var(--bs-secondary-subtle);
  background-color: transparent;
}
.Header > .row.HeaderFilters .Filters .btn:not(.btn-success) input,
.Header > .row.HeaderFilters .Filters .form-control input,
.Header > .row.HeaderFilters .Filters .Select input {
  background-color: transparent;
}
.Header > .row.HeaderFilters .Filters .btn:not(.btn-success)::placeholder,
.Header > .row.HeaderFilters .Filters .btn:not(.btn-success) input::placeholder,
.Header > .row.HeaderFilters .Filters .form-control::placeholder,
.Header > .row.HeaderFilters .Filters .form-control input::placeholder,
.Header > .row.HeaderFilters .Filters .Select::placeholder,
.Header > .row.HeaderFilters .Filters .Select input::placeholder {
  color: var(--bs-secondary-subtle) !important;
}
.Header > .row.HeaderFilters .Filters .btn:not(.btn-success):hover,
.Header > .row.HeaderFilters .Filters .btn:not(.btn-success):focus,
.Header > .row.HeaderFilters .Filters .form-control:hover,
.Header > .row.HeaderFilters .Filters .form-control:focus,
.Header > .row.HeaderFilters .Filters input:focus,
.Header > .row.HeaderFilters .Filters .dropdown:hover,
.Header > .row.HeaderFilters .Filters .dropdown.show > button {
  color: var(--bs-secondary);
  border-color: var(--bs-secondary) !important;
}
.Header > .row.HeaderFilters .Filters .btn:not(.btn-success):hover input::placeholder,
.Header > .row.HeaderFilters .Filters .btn:not(.btn-success):focus input::placeholder,
.Header > .row.HeaderFilters .Filters .form-control:hover input::placeholder,
.Header > .row.HeaderFilters .Filters .form-control:focus input::placeholder,
.Header > .row.HeaderFilters .Filters input:focus input::placeholder,
.Header > .row.HeaderFilters .Filters .dropdown:hover input::placeholder,
.Header > .row.HeaderFilters .Filters .dropdown.show > button input::placeholder {
  color: var(--bs-secondary) !important;
}
.Header > .row.HeaderFilters .Filters .btn:not(.btn-success):hover::placeholder,
.Header > .row.HeaderFilters .Filters .btn:not(.btn-success):focus::placeholder,
.Header > .row.HeaderFilters .Filters .form-control:hover::placeholder,
.Header > .row.HeaderFilters .Filters .form-control:focus::placeholder,
.Header > .row.HeaderFilters .Filters input:focus::placeholder,
.Header > .row.HeaderFilters .Filters .dropdown:hover::placeholder,
.Header > .row.HeaderFilters .Filters .dropdown.show > button::placeholder {
  color: var(--bs-secondary) !important;
}
.Header > .row.HeaderFilters .Filters {
  /*SEARCHBAR*/
}
.Header > .row.HeaderFilters .Filters .grouped-input {
  border-width: 1px;
}
.Header > .row.HeaderFilters .Filters .grouped-input input {
  box-shadow: none;
}
.Header > .row.HeaderFilters .Filters .grouped-input .prepend {
  padding-right: 0;
  background: transparent;
}
.Header > .row.HeaderFilters .Filters .grouped-input .append {
  padding-left: 0;
}
.Header > .row.HeaderFilters .Filters .grouped-input .input-group-text {
  border: none;
  color: var(--bs-secondary-subtle);
}
.Header > .row.HeaderFilters .Filters .grouped-input:hover {
  border-color: var(--bs-secondary);
}
.Header > .row.HeaderFilters .Filters .grouped-input:hover .input-group-text,
.Header > .row.HeaderFilters .Filters .grouped-input:hover input::placeholder {
  color: var(--bs-secondary) !important;
}
.Header > .row.HeaderFilters .ant-switch .ant-switch-inner {
  border: 1px solid rgba(255, 255, 255, 0.4);
}
.Header > .row.HeaderInfo {
  height: var(--info-height);
}
.Header > .row:last-of-type {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}

.RouteContent {
  height: 100%;
  padding: 0 4rem;
  overflow: auto;
}

.Shortcut {
  position: relative;
}
.Shortcut a {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: var(--bs-secondary-subtle);
  text-decoration: none;
}
.Shortcut a > .badge {
  position: absolute;
  font-size: 0.9rem;
  top: 0;
  right: -1rem;
  border: 1px solid var(--bs-light);
}

.NavigationDrawer {
  width: 256px !important;
  background-color: var(--bs-primary);
  border-right: 1px solid #fff !important;
}
.NavigationDrawer .CloseButton {
  color: #fff;
}
.NavigationDrawer .Drawer-Header {
  border-bottom: 1px solid rgba(255, 255, 255, 0.15) !important;
}
.NavigationDrawer .Drawer-Header .Drawer-Title {
  color: #fff !important;
  padding-bottom: 0 !important;
}
.NavigationDrawer .NavigationDrawer-Header {
  display: flex;
  width: 100%;
  gap: 0.5rem;
  padding-bottom: 1rem;
}
.NavigationDrawer .NavigationDrawer-Header .NavigationDrawer-Avatar .ImageDisplay {
  border-radius: var(--bs-border-radius);
}
.NavigationDrawer .NavigationDrawer-Header .NavigationDrawer-Avatar .ImageDisplay .fa-user {
  opacity: 0.25;
  color: #fff !important;
}
.NavigationDrawer .NavigationDrawer-Header .NavigationDrawer-Info {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  justify-content: space-between;
}
.NavigationDrawer .NavigationDrawer-Header .NavigationDrawer-Info button {
  padding: 0;
}
.NavigationDrawer .Drawer-Body {
  padding: 0.5rem 1rem !important;
}
.NavigationDrawer .Drawer-Body::-webkit-scrollbar-thumb {
  background-color: var(--bs-light);
  border: 3px solid var(--bs-primary);
}
.NavigationDrawer, .NavigationDrawer:focus,
.NavigationDrawer .btn-text,
.NavigationDrawer .btn-text:focus,
.NavigationDrawer .NavigationDrawer-Item,
.NavigationDrawer .NavigationDrawer-Item:focus {
  color: #fff;
  font-weight: 600;
}
.NavigationDrawer .NavigationDrawer-ItemGroup {
  padding: 0.65rem 0;
  gap: 0.65rem;
}
.NavigationDrawer .NavigationDrawer-ItemGroup .NavigationDrawer-Item {
  display: flex;
  gap: 1.4rem;
  background-color: transparent;
  border: none;
  text-transform: uppercase;
  vertical-align: middle;
  border-radius: 0.75rem;
}
.NavigationDrawer .NavigationDrawer-ItemGroup .NavigationDrawer-Item > span {
  display: flex;
  flex-direction: column;
  justify-content: center;
  line-height: 1rem;
}
.NavigationDrawer .NavigationDrawer-ItemGroup .NavigationDrawer-Item > span + span {
  display: flex;
  flex-grow: 1;
}
.NavigationDrawer .NavigationDrawer-ItemGroup .NavigationDrawer-Item > span:first-child:not(:last-child), .NavigationDrawer .NavigationDrawer-ItemGroup .NavigationDrawer-Item > span + span,
.NavigationDrawer .NavigationDrawer-ItemGroup .NavigationDrawer-Item > span + i.sv-chevron-right,
.NavigationDrawer .NavigationDrawer-ItemGroup .NavigationDrawer-Item > span + i.sv-cross {
  line-height: 2rem;
}
.NavigationDrawer .NavigationDrawer-ItemGroup .NavigationDrawer-Item i:not(.sv-chevron-right):not(.sv-cross) {
  font-size: 2rem;
}
.NavigationDrawer .NavigationDrawer-ItemGroup .NavigationDrawer-Item:not(:empty) {
  cursor: pointer;
  transition: background-color 0.5s, box-shadow 0.25s;
}
.NavigationDrawer .NavigationDrawer-ItemGroup .NavigationDrawer-Item:not(:empty):hover, .NavigationDrawer .NavigationDrawer-ItemGroup .NavigationDrawer-Item:not(:empty).open {
  background-color: rgba(255, 255, 255, 0.02) !important;
  box-shadow: 3.2142744064px 4.2856988907px 12.8570976257px -2.1428494453px rgba(0, 0, 0, 0.3490196078) !important;
  color: #fff;
}
.NavigationDrawer .NavigationDrawer-ItemGroup .NavigationDrawer-Item:not(:empty):active {
  color: #fff;
}
.NavigationDrawer .NavigationDrawer-ItemGroup .NavigationDrawer-Controls {
  border-top: 1px solid rgba(255, 255, 255, 0.15);
  border-bottom: 1px solid rgba(255, 255, 255, 0.15);
}
.NavigationDrawer.Drawer-Menu {
  z-index: 1044;
}
.NavigationDrawer.Drawer-Menu.show {
  transform: translateX(256px) !important;
}
.NavigationDrawer.Drawer-Menu .Drawer-Header {
  padding: 0.5rem 0;
}
.NavigationDrawer.Drawer-Menu .Drawer-Header .Drawer-Title {
  font-size: 1.15rem;
}
.NavigationDrawer.Drawer-Menu .NavigationDrawer-ItemGroup .NavigationDrawer-Item span {
  line-height: 1.25rem !important;
}
.NavigationDrawer.Drawer-Menu .NavigationDrawer-ItemGroup .NavigationDrawer-Item i {
  font-size: 1.25rem !important;
}`, "",{"version":3,"sources":["webpack://./src/components/Header/styles.scss"],"names":[],"mappings":"AAKA;EACE,yBAAA;EACA,0BAAA;EACA,sBAAA;EACA,mBAAA;AAJF;;AAOA;EACE,YAAA;EACA,WAAA;AAJF;AAMI;EACE,WAAA;EACA,iBAAA;AAJN;AAOE;;;;EAIE,gDAAA;AALJ;AAOE;EACE,6BAAA;EACA,eAAA;AALJ;AAMI;EACE,gDAAA;AAJN;AAMI;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;AAJN;AAMI;EACE,+EAAA;EACA,wBAAA;EACA,4BAAA;EACA,wCAAA;EACA,2DAAA;EACA,gCAAA;AAJN;AAKM;EACE,kBAAA;EACA,iCAAA;EACA,iBAAA;EACA,8CAAA;AAHR;AAIQ;EACE,eAAA;EACA,iBAAA;AAFV;AAGU;EACE,0BAAA;AADZ;AAMI;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;AAJN;AAMM;EACE,6BAAA;EACA,iCAAA;AAJR;AAKQ;;;;EAIE,qCAAA;AAHV;AAKQ;EACE,4CAAA;EACA,6BAAA;AAHV;AAKY;;EAEE,iCAAA;AAHd;AAMU;EAEE,gDAAA;AALZ;AAOc;;;EAEE,0BAAA;AAJhB;AASQ;EACE,4CAAA;AAPV;AASQ;EACE,YAAA;EACA,aAAA;EACA,mBAAA;AAPV;AAQU;EACE,wCAAA;AANZ;AASQ;;;EAGE,iCAAA;EACA,6BAAA;AAPV;AAQU;;;EACE,6BAAA;AAJZ;AAMU;;;;;;EAEE,4CAAA;AAAZ;AAGQ;;;;;;;EAOE,0BAAA;EACA,4CAAA;AADV;AAEU;;;;;;;EACE,qCAAA;AAMZ;AAJU;;;;;;;EACE,qCAAA;AAYZ;AA9EM;EAqEE,YAAA;AAYR;AAXQ;EACE,iBAAA;AAaV;AAZU;EACE,gBAAA;AAcZ;AAZU;EACE,gBAAA;EACA,uBAAA;AAcZ;AAZU;EACE,eAAA;AAcZ;AAZU;EACE,YAAA;EACA,iCAAA;AAcZ;AAZU;EACE,iCAAA;AAcZ;AAbY;;EAEE,qCAAA;AAed;AAVM;EACE,0CAAA;AAYR;AATI;EACE,0BAAA;AAWN;AATI;EACE,wDAAA;AAWN;;AAPA;EACE,YAAA;EACA,eAAA;EACA,cAAA;AAUF;;AAPA;EACE,kBAAA;AAUF;AATE;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,iCAAA;EACA,qBAAA;AAWJ;AAVI;EACE,kBAAA;EACA,iBAAA;EACA,MAAA;EACA,YAAA;EACA,iCAAA;AAYN;;AAFA;EACE,uBAAA;EACA,mCANiB;EAOjB,uCAAA;AAKF;AAJE;EACE,WAAA;AAMJ;AAJE;EACE,6DAAA;AAMJ;AALI;EACE,sBAAA;EACA,4BAAA;AAON;AAJE;EACE,aAAA;EACA,WAAA;EACA,WAAA;EACA,oBAAA;AAMJ;AAHM;EACE,sCAAA;AAKR;AAJQ;EACE,aAAA;EACA,sBAAA;AAMV;AAFI;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,8BAAA;AAIN;AAHM;EACE,UAAA;AAKR;AADE;EACE,+BAAA;AAGJ;AAFI;EACE,iCAAA;EACA,mCAAA;AAIN;AAEI;;;;;EAEE,WArDO;EAsDP,gBAAA;AAGN;AAAE;EACE,kBAAA;EACA,YAAA;AAEJ;AADI;EACE,aAAA;EACA,WAAA;EACA,6BAAA;EACA,YAAA;EACA,yBAAA;EACA,sBAAA;EACA,sBAAA;AAGN;AAFM;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,iBAAA;AAIR;AAHQ;EACE,aAAA;EACA,YAAA;AAKV;AAHQ;;;EAIE,iBAAA;AAIV;AADM;EACE,eAAA;AAGR;AADM;EACE,eAAA;EACA,mDACE;AAEV;AAAQ;EAEE,sDAAA;EACA,gHAAA;EACA,WAhGG;AAiGb;AACQ;EACE,WAnGG;AAoGb;AAGI;EACE,+CAAA;EACA,kDAAA;AADN;AAIE;EACE,aAAA;AAFJ;AAGI;EACE,uCAAA;AADN;AAGI;EACE,iBAAA;AADN;AAEM;EACE,kBAAA;AAAR;AAKQ;EACE,+BAAA;AAHV;AAKQ;EACE,6BAAA;AAHV","sourcesContent":["$NavigationHeight: 60px;\n$QuickLinksHeight: 40px;\n$FiltersHeight: 54px;\n$InfoHeight: 36px;\n\n.Header {\n  --navigation-height: #{$NavigationHeight};\n  --quick-links-height: #{$QuickLinksHeight};\n  --filters-height: #{$FiltersHeight};\n  --info-height: #{$InfoHeight};\n}\n\n.Header {\n  width: 100vw;\n  z-index: 50;\n  .NavigationDrawer-Button {\n    i {\n      color: #fff;\n      font-size: 2.5rem;\n    }\n  }\n  .NavLinks,\n  .Filters .FormField,\n  .Filters .btn,\n  .Dropdown {\n    box-shadow: 4px 5px 16px 0px rgba(0, 0, 0, 0.35);\n  }\n  > .row {\n    background: var(--bs-primary);\n    padding: 0 4rem;\n    + .row {\n      border-top: 1px solid var(--bs-secondary-subtle);\n    }\n    > .col:not(.HeaderInfo > .col) {\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n    }\n    &.HeaderNavigation {\n      background-image: url('../../../public/assets/images/Skyplan_header_Logo1.png');\n      background-size: contain;\n      background-repeat: no-repeat;\n      background-position: 50% calc(50% + 3px);\n      background-size: auto calc(var(--navigation-height) - 10px);\n      height: var(--navigation-height);\n      .NavLinks {\n        width: fit-content;\n        height: var(--quick-links-height);\n        padding: 0 1.5rem;\n        border: 0.5px solid var(--bs-secondary-subtle);\n        a {\n          cursor: pointer;\n          font-size: 1.9rem;\n          i:hover {\n            color: var(--bs-secondary);\n          }\n        }\n      }\n    }\n    &.HeaderFilters {\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      // TODO: Clean up the filters styles - a lot of these can be better grouped/combined.\n      .Filters {\n        background: var(--bs-primary);\n        color: var(--bs-secondary-subtle);\n        .FormField-Wrapper,\n        .ant-picker,\n        .btn,\n        *:not(.grouped-input) > .form-control {\n          height: var(--info-height) !important;\n        }\n        .ant-picker {\n          border: 1px solid var(--bs-secondary-subtle);\n          background-color: transparent;\n          .ant-picker-input {\n            input,\n            span {\n              color: var(--bs-secondary-subtle);\n            }\n          }\n          &:hover,\n          &.ant-picker-focused {\n            border: 1px solid var(--bs-secondary) !important;\n            .ant-picker-input {\n              input,\n              span {\n                color: var(--bs-secondary);\n              }\n            }\n          }\n        }\n        .btn {\n          border: 1px solid var(--bs-secondary-subtle);\n        }\n        .form-control {\n          height: 100%;\n          display: flex;\n          align-items: center;\n          &:not(.is-invalid) {\n            border-color: var(--bs-secondary-subtle);\n          }\n        }\n        .btn:not(.btn-success),\n        .form-control,\n        .Select {\n          color: var(--bs-secondary-subtle);\n          background-color: transparent;\n          input {\n            background-color: transparent;\n          }\n          &::placeholder,\n          input::placeholder {\n            color: var(--bs-secondary-subtle) !important;\n          }\n        }\n        .btn:not(.btn-success):hover,\n        .btn:not(.btn-success):focus,\n        .form-control:hover,\n        .form-control:focus,\n        input:focus,\n        .dropdown:hover,\n        .dropdown.show > button {\n          color: var(--bs-secondary);\n          border-color: var(--bs-secondary) !important;\n          input::placeholder {\n            color: var(--bs-secondary) !important;\n          }\n          &::placeholder {\n            color: var(--bs-secondary) !important;\n          }\n        }\n        /*SEARCHBAR*/\n        .grouped-input {\n          border-width: 1px;\n          input {\n            box-shadow: none;\n          }\n          .prepend {\n            padding-right: 0;\n            background: transparent;\n          }\n          .append {\n            padding-left: 0;\n          }\n          .input-group-text {\n            border: none;\n            color: var(--bs-secondary-subtle);\n          }\n          &:hover {\n            border-color: var(--bs-secondary);\n            .input-group-text,\n            input::placeholder {\n              color: var(--bs-secondary) !important;\n            }\n          }\n        }\n      }\n      .ant-switch .ant-switch-inner {\n        border: 1px solid rgba(255, 255, 255, 0.4);\n      }\n    }\n    &.HeaderInfo {\n      height: var(--info-height);\n    }\n    &:last-of-type {\n      box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;\n    }\n  }\n}\n.RouteContent {\n  height: 100%;\n  padding: 0 4rem;\n  overflow: auto;\n}\n\n.Shortcut {\n  position: relative;\n  a {\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    color: var(--bs-secondary-subtle);\n    text-decoration: none;\n    > .badge {\n      position: absolute;\n      font-size: 0.9rem;\n      top: 0;\n      right: -1rem;\n      border: 1px solid var(--bs-light);\n    }\n  }\n}\n\n$WIDTH: 256px;\n$BACKGROUND_COLOR: var(--bs-primary);\n$BORDER: 1px solid #fff;\n$TEXT_COLOR: #fff;\n\n.NavigationDrawer {\n  width: $WIDTH !important;\n  background-color: $BACKGROUND_COLOR;\n  border-right: $BORDER !important;\n  .CloseButton {\n    color: #fff;\n  }\n  .Drawer-Header {\n    border-bottom: 1px solid rgba(255, 255, 255, 0.15) !important;\n    .Drawer-Title {\n      color: $TEXT_COLOR !important;\n      padding-bottom: 0 !important;\n    }\n  }\n  .NavigationDrawer-Header {\n    display: flex;\n    width: 100%;\n    gap: 0.5rem;\n    padding-bottom: 1rem;\n    // border-bottom: 1px solid rgba(255, 255, 255, 0.15);\n    .NavigationDrawer-Avatar {\n      .ImageDisplay {\n        border-radius: var(--bs-border-radius);\n        .fa-user {\n          opacity: 0.25;\n          color: #fff !important;\n        }\n      }\n    }\n    .NavigationDrawer-Info {\n      display: flex;\n      flex-direction: column;\n      flex-grow: 1;\n      justify-content: space-between;\n      button {\n        padding: 0;\n      }\n    }\n  }\n  .Drawer-Body {\n    padding: 0.5rem 1rem !important;\n    &::-webkit-scrollbar-thumb {\n      background-color: var(--bs-light);\n      border: 3px solid var(--bs-primary);\n    }\n  }\n  &,\n  .btn-text,\n  .NavigationDrawer-Item {\n    &,\n    &:focus {\n      color: $TEXT_COLOR;\n      font-weight: 600;\n    }\n  }\n  .NavigationDrawer-ItemGroup {\n    padding: 0.65rem 0;\n    gap: 0.65rem;\n    .NavigationDrawer-Item {\n      display: flex;\n      gap: 1.4rem;\n      background-color: transparent;\n      border: none;\n      text-transform: uppercase;\n      vertical-align: middle;\n      border-radius: 0.75rem;\n      > span {\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        line-height: 1rem;\n        + span {\n          display: flex;\n          flex-grow: 1;\n        }\n        &:first-child:not(:last-child),\n        & + span,\n        + i.sv-chevron-right,\n        + i.sv-cross {\n          line-height: 2rem;\n        }\n      }\n      i:not(.sv-chevron-right):not(.sv-cross) {\n        font-size: 2rem;\n      }\n      &:not(:empty) {\n        cursor: pointer;\n        transition:\n          background-color 0.5s,\n          box-shadow 0.25s;\n        &:hover,\n        &.open {\n          background-color: rgba(255, 255, 255, 0.02) !important;\n          box-shadow: 3.2142744064px 4.2856988907px 12.8570976257px -2.1428494453px rgba(0, 0, 0, 0.3490196078) !important;\n          color: $TEXT_COLOR;\n        }\n        &:active {\n          color: $TEXT_COLOR;\n        }\n      }\n    }\n    .NavigationDrawer-Controls {\n      border-top: 1px solid rgba(255, 255, 255, 0.15);\n      border-bottom: 1px solid rgba(255, 255, 255, 0.15);\n    }\n  }\n  &.Drawer-Menu {\n    z-index: 1044;\n    &.show {\n      transform: translateX(256px) !important;\n    }\n    .Drawer-Header {\n      padding: 0.5rem 0;\n      .Drawer-Title {\n        font-size: 1.15rem;\n      }\n    }\n    .NavigationDrawer-ItemGroup {\n      .NavigationDrawer-Item {\n        span {\n          line-height: 1.25rem !important;\n        }\n        i {\n          font-size: 1.25rem !important;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
